import { Box, Grid, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import TableFiltersSkeleton from "../../components/skeletons/TableFiltersSkeleton";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { GetEnumsResponse } from "../../models/enum.model";
import {
  GetSalesSearchResponse,
  SalesSearchFilter,
} from "../../models/sale.model";
import { PaginationInfo } from "../../models/security.model";
import { AllStoresAndBranchesResponse } from "../../models/supplierUserBarnch.model";
import { GetAllStoresAndBranches } from "../../services/dropdown.service";
import { getEnumsPersian } from "../../services/enum.services";
import {
  GetSalesSearch,
  GetSalesSearchExcel,
} from "../../services/sale.service";
import SaleListFilters from "./components/SaleListFilters";
import SalesFactorTable from "./components/SalesFactorTable";

const SaleFactorsSearch = () => {
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [showFilter, setShowFilter] = useState(true);
  const [saleFactorsList, setSaleFactorsList] = useState<
    GetSalesSearchResponse[]
  >([]);
  const [saleTypes, setSaleTypes] = useState<GetEnumsResponse[]>();
  const [filterObject, setFilterObject] = useState<SalesSearchFilter>();
  const [saleStatusType, setSaleStatusType] = useState<GetEnumsResponse[]>();
  const [allStoresAndBranches, setAllStoresAndBranches] = useState<
    AllStoresAndBranchesResponse[]
  >();

  // service calls
  const { mutate: GetSalesSearchMutate } = useMutation(GetSalesSearch, {
    onSuccess: (data: ApiResultModel<GetSalesSearchResponse[]>) => {
      if (data) {
        setSaleFactorsList(data.data);
        setPageInfo(data.pageInfo);
      }
    },
    onError: () => {},
  });
  const { mutate: getEnumsPersianMutate, isLoading } = useMutation(
    getEnumsPersian,
    {
      onSuccess: (data: GetEnumsResponse[]) => {
        if (data) {
          setSaleTypes(data.filter((x) => x.enumName === "SaleType"));
          setSaleStatusType(data.filter((x) => x.enumName === "SaleStatus"));
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetSalesSearchExcelMutate } = useMutation(
    GetSalesSearchExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetAllStoresAndBranchesMutate } = useMutation(
    GetAllStoresAndBranches,
    {
      onSuccess: (data: AllStoresAndBranchesResponse[]) => {
        if (data) {
          setAllStoresAndBranches(data);
        }
      },
      onError: () => {},
    }
  );

  // handlers
  const handleClick = (key: string) => {
    const newWindow = window.open("/#/StoreRequestDetail", "_blank");
    newWindow?.sessionStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({ saleKey: key })
    );
    newWindow?.history.pushState(
      {
        settlementData: { saleKey: key },
      },
      "",
      "/StoreRequestDetail"
    );
  };

  const handleExportExcel = () => {
    GetSalesSearchExcelMutate({
      ...filterObject,
    });
  };

  useEffect(() => {
    getEnumsPersianMutate({ enumNames: ["SaleType", "SaleStatus"] });
    GetAllStoresAndBranchesMutate({});
  }, []);
  useEffect(() => {
    GetSalesSearchMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title='فیلتر' arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src='images/filter.png'
                alt=''
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title='خروجی اکسل' arrow>
              <img
                onClick={handleExportExcel}
                className='cursorPointer'
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src='images/ExportXLS.svg'
                alt='ExportXLS'
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter &&
          (!isLoading ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <SaleListFilters
                filterObject={filterObject!}
                saleTypes={saleTypes!}
                setFilterObject={setFilterObject}
                branches={allStoresAndBranches!}
                saleStatusType={saleStatusType!}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableFiltersSkeleton />
            </span>
          ))}
        <Grid item xs={12}>
          <SalesFactorTable
            saleFactorsList={saleFactorsList}
            pageInfo={pageInfo}
            currentPaginationInfo={currentPaginationInfo}
            setCurrentPaginationInfo={setCurrentPaginationInfo}
            handleClick={handleClick}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SaleFactorsSearch;
